module.exports = __webpack_public_path__ + "img/Currency-new.6b5c6f2c.svg";